export default function TabBar({ tabs, active, onChange }) {
  return (
    <div className="tab-bar" role="tablist">
      {(tabs || []).map((t) => {
        const id = t.id || t.key;
        const selected = active === id;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={selected}
            className={`tab-btn${selected ? ' active' : ''}`}
            onClick={() => onChange(id)}
          >
            {t.icon}
            <span>{t.label}</span>
            {t.count != null && <span className="tab-count">{t.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
